import { IconButton } from '@aibees/shared/components';
import { SIDENAV } from '@aibees/shared/layouts/config-layout';
import { Box, Drawer, Paper as PaperBase, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Drawer)`
  position: absolute;
`;

export const LogoWrapper = styled(Box)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: ${(p) => p.theme.spacing(1.5, 0)};
  /* gap: ${(p) => p.theme.spacing(4.5)}; */
  border-bottom: ${(p) => `solid 1px ${p.theme.palette.primary[100]}`};
  &.open {
    justify-content: flex-start;
  }
`;

export const Logo = styled('img')`
  width: ${(p) => p.theme.spacing(4)};
  height: ${(p) => p.theme.spacing(4)};
`;

export const Backdrop = styled(Box)`
  opacity: 0;
  position: fixed;
  background: ${(p) => alpha(p.theme.palette.common.black, 0.2)};
  height: 100vh;
  top: 0;
  bottom: 0;
  left: ${(p) => p.theme.spacing(25)};
  transition: all 0.2s ease-in-out;
  &.show {
    opacity: 1;
    right: 0;
  }
`;

export const Brand = styled('img')`
  height: ${(p) => p.theme.spacing(3.5)};
  align-self: center;
  margin-left: ${(p) => p.theme.spacing(2)};
`;

export const ButtonWrapper = styled(Box)`
  /* display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: ${(p) => p.theme.spacing(1)};
  gap: ${(p) => p.theme.spacing(1)};
  cursor: pointer;
  &:hover {
    .AppBadgeName {
      opacity: 1;
      display: inline-block;
    }
  } */
`;

export const Button = styled(IconButton)`
  /* display: flex;
  height: ${(p) => p.theme.spacing(5)};
  width: ${(p) => p.theme.spacing(5)};
  border: solid 2px ${(p) => p.theme.palette.grey[200]};
  &:hover {
    border-color: ${(p) => p.theme.palette.primary[500]};
  }
  &.active {
    border-color: ${(p) => p.theme.palette.primary[500]};
  } */
`;

export const Paper = styled(PaperBase)`
  /* background-color: ${(p) => p.theme.palette.common.white}; */
`;

export const MenuContainer = styled(Box)`
  display: flex;
  height: 100%;
  gap: ${(p) => p.theme.spacing(1.5)};
  padding: ${(p) => p.theme.spacing(0, 0.5, 0.5, 0.5)};

  flex-direction: column;
  background-color: ${(p) =>
    p.theme.palette.mode === 'dark'
      ? p.theme.palette.grey[800]
      : p.theme.palette.common.white};
  align-items: center;
  overflow-x: hidden;

  &.open {
    width: ${SIDENAV.W_EXPANDED}px;
    transition: ${(p) =>
      p.theme.transitions.create(['width'], {
        easing: p.theme.transitions.easing.easeOut,
        duration: p.theme.transitions.duration.enteringScreen,
      })};
  }
  &.close {
    width: ${SIDENAV.W}px;
    transition: ${(p) =>
      p.theme.transitions.create(['width'], {
        easing: p.theme.transitions.easing.easeOut,
        duration: p.theme.transitions.duration.leavingScreen,
      })};
  }
`;
